import styled from 'styled-components';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import {
  FontSize,
  FontWeight,
  FONT_STACK,
  STANDARD_TRANSITION,
  STANDARD_SHRINK,
} from '../../../../../styles/constants';
import { HIDE_SCROLL_BAR } from '../../../../../styles/mixins';

export const SeeAll = styled.button`
  ${FONT_STACK}
  ${STANDARD_TRANSITION};
  ${HIDE_SCROLL_BAR};
  background-color: ${ThemeColours.white};
  border: none;
  color: ${ThemeColours.primary500};
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  float: right;
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 24px;
  justify-content: center;
  margin: 0px;
  padding: 0px;

  &:active {
    transform: scale(${STANDARD_SHRINK});
  }
`;
